import axios from '@/axios.js'
let entityURL = 'notifications'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

const state = {
    allNotifications: [],
    notification: {},
}

const getters = {
    getAllNotifications: (state) => (state.allNotifications),
    // getNotification: (state) => (state.notification),
}

const actions = {
    // Fetch all notifications
    async fetchAllNotifications({commit}) {
        const response = await axios(`${entityURL}/list`)
        let ar = []
        response.data.forEach((obj, index) => {
            if (obj.type.includes('ScheduleCompleted')) {
                //console.log('333')
                ar.push({
                    id       : obj.id,
                    index    : index,
                    number   : index+1,
                    title    : 'Έλεγχος τιμών',
                    msg      : 'Η διαδικασία ολοκληρώθηκε με επιτυχία',
                    icon     : 'MessageSquareIcon',
                    time     : obj.created_at,
                    is_read     : obj.read_at?true:false,
                    category : 'primary'
                })

            }
            //console.log(ar)

        })
        commit('SET_NOTIFICATIONS', ar)

    },

    async setNotificationStatus({ commit }, payload) {
        const response = await axios.post(`${entityURL}/read`, payload)
        commit('UPDATE_NOTIFICATIONS', response.data.object)
    },

}

const mutations = {
    SET_NOTIFICATIONS: (state, data) => (state.allNotifications = data),
    UPDATE_NOTIFICATIONS: (state, data) => {
        const index = state.allNotifications.findIndex(x => x.id === data.id)
        if (index !== -1) {
            let d = state.allNotifications[index]
            d.is_read = data.read_at?true:false;
            state.allNotifications.splice(index, 1, d)
        }
    },
}


export default { state, getters, actions, mutations }
